import { ApiClient, PublicApiClient } from '../../../setup/axios/SetupAxios'
import { ListQueryParams } from '../ApiClient'

export class HazardStatusQueryParams extends ListQueryParams {
    WithEnabled(value: boolean) {
        this.WithParam('active', value)
        return this
    }
    WithTileOnly(value: boolean) {
        this.WithParam('tileOnly', value)
        return this
    }
    WithIncludeCount(value: boolean) {
        this.WithParam('includeCount', value)
        return this
    }
}

export class HazardStatusClient {
    static async List(params: HazardStatusQueryParams) {
        return await ApiClient.Get('/hazard-status' + params.GenerateQueryString());
    }

    static async PublicList(params: HazardStatusQueryParams) {
        return await PublicApiClient.Get('/hazard-status/public-list' + params.GenerateQueryString());
    }

    static async Delete(id: string) {
        return await ApiClient.Delete('/hazard-status' + id);
    }

    static async Get(id: string) {
        return await ApiClient.Get('/hazard-status' + id);
    }

    static async Create(
        name: string,
        color: string,
        active: boolean,
        isdefault: boolean,
        tile: boolean,
        emails: string
    ) {

        return await ApiClient.Post('/hazard-status', {
            name,
            color,
            active,
            default: isdefault,
            tile,
            emails,
        });
    }

    static async Update(
        id: string,
        name: string,
        color: string,
        active: boolean,
        isdefault: boolean,
        tile: boolean,
        emails: string
    ) {
        return await ApiClient.Patch('/hazard-status/' + id, [
            {
                op: 'replace',
                path: 'name',
                value: name,
            },
            {
                op: 'replace',
                path: 'color',
                value: color,
            },
            {
                op: 'replace',
                path: 'active',
                value: active,
            },
            {
                op: 'replace',
                path: 'default',
                value: isdefault,
            },
            {
                op: 'replace',
                path: 'tile',
                value: tile,
            },
            {
                op: 'replace',
                path: 'emails',
                value: emails,
            },
        ]);
    }
}
